// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_pIu","cls2":"Comments-cls2_tqA Comments-cls1_pIu"};